export default __webpack_public_path__ + "static/media/chat-engineer-side.b5a4fb85.png";